import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import { SubscriptionPlanComponent } from 'src/app/user/subscription-plan/subscription-plan.component';
import Swal from 'sweetalert2';
import { LrsUploadDocumentComponent } from '../lrs-upload-document/lrs-upload-document.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-lrs-request',
  templateUrl: './lrs-request.component.html',
  styleUrls: ['./lrs-request.component.scss']
})
export class LrsRequestComponent implements OnInit {
  UserID: any;
  data: any;
  list:FormGroup
  isLoading: boolean = true;
  breadCrumbItems: Array<{}>;
  Document: any;
  length: any;
  Form:FormGroup
  statedata: any;
  StateList: any;

  constructor(private route: ActivatedRoute, private dialog: MatDialog, private router: Router,
    private Fb: FormBuilder, private generalService: GeneralService) { 
    let a = this.router.getCurrentNavigation().extras
    if(a){
      if(a.state){
        this.UserID = a.state.id
        console.log("thisuserid",this.UserID)
        localStorage.setItem('id',this.UserID)
      }
    }
    if(localStorage.getItem('id')){
      this.UserID = localStorage.getItem('id')
    }
    this.breadCrumbItems = [
      { label: "User Details", path: "/users/users-users-details" },
      { label: "LRS Requested Documents", path: "/", active: true },
    ];

  }

  ngOnInit() {
    this.Form = new FormGroup({
      stateID: new FormControl(null)
    });
    // this.list = this.Fb.group({
    //   state: new FormControl(null)
    // })
    this.UserLrsdetails()
    this.fetchstatelist()
  }
  ngAfterViewInit(){
    this.UserLrsdetails();
  }
  UserLrsdetails(){
    this.generalService.getLRSUserList(this.UserID).subscribe((res:any) =>{
      this.data = res.data
      this.Document = res.data
      this.length = res.TotalCount 
      console.log('document data',res.data)
      console.log('count',res.TotalCount)
      this.isLoading = false;
      console.log('data',this.data)
    })
  }
  onViewDocument(url){
    this.router.navigate(['/users/view-document/' + this.UserID],{state : {UserId:this.UserID,URL:url}})
  }
  fetchstatelist() {
    this.generalService.LRSState().subscribe((res:any)=>{
      this.StateList = res

    })
        
    // this.f.DistrictID.disable();
  }

  selectEvent(id){
    this.isLoading=true
    if(id !== undefined || this.Form.controls.stateID.value !== null){
      this.generalService.LRSStateSearch(this.UserID,id).subscribe((res:any)=>{
        this.data = res.data
        this.statedata = res.TotalCount
        console.log('TotalCount',this.statedata)
        this.isLoading= false
      })
    }else{
      this.UserLrsdetails()
      this.isLoading= false
    }

  }
  uploadDoc(id,docName,stateID){
    const dialogRef = this.dialog.open(LrsUploadDocumentComponent,{
      width: '600px',
      maxHeight: '90vh',
      data:{
        UserID:this.UserID,
        AdhocServiceID:id,
        Docname:docName
      }
    }).afterClosed().subscribe((res)=>{
      if(res){
        // this.UserLrsdetails()
        this.selectEvent(stateID)
      }
    })
  }
}
